import React, { useState, useEffect } from 'react';

import GenericEditable from './shared/GenericEditable';
import DisplayText from './text/DisplayText';
import EditText from './text/EditText';

/**
 * Name editable in popup after click. Value can't be saved as emtpy string "Får inte vara tomt.".
 * @param {string} [initialValue] Initial field value.
 * @param {function} [customDisplayWrapper] [string=>component]Optional wrapper for the displayed value (e.g. for setting <h1>).
 * @param {string} [description] E.g. "Rename this person", shown in the dropdown.
 * @param {function} [handleSave] [async string=>{bool success, string message}] Save changes / return error message.
 */
const EditableName = ({
    initialValue: onPageLoadValue,
    customDisplayWrapper,
    description,
    handleSave: syncChanges,
    updateStore,
    updateOrganizationsInStore,
}) => {
    const [value, setValue] = useState(onPageLoadValue ?? '');
    const [initialValue, setInitialValue] = useState(onPageLoadValue ?? '');

    useEffect(() => {
        setValue(onPageLoadValue ?? '');
        setInitialValue(onPageLoadValue ?? '');
    }, [onPageLoadValue]);

    const valueHasntChanged = () => {
        return value === initialValue;
    };

    const handleSave = async () => {
        if (value === '') {
            return { success: false, message: 'Får inte vara tomt.' };
        }
        const response = await syncChanges(value);
        if (response.success) {
            if (response.deal) {
                updateStore(response.deal);
            }
            if (response.organization) {
                updateStore(response.organization);
                updateOrganizationsInStore(response.organization);
            }
            if (response.person) {
                updateStore(response.person);
            }
            setInitialValue(value);
        }
        return response;
    };

    const handleCancel = () => {
        setValue(initialValue);
    };

    return (
        <GenericEditable {...{ handleSave, handleCancel, customDisplayWrapper, description, valueHasntChanged }}>
            <DisplayText {...{ value: initialValue }} />
            <EditText {...{ value, setValue }} />
        </GenericEditable>
    );
};

export default EditableName;
